import Dependencies from '../utilities/dependencies';

export default class HeaderMobile {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['header.mobile-view'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {HTMLElement} */
	#menuBtn;

	/** @type {HTMLElement} */
	#menuView;

	/** @type {HTMLElement} */
	#bookingButtons;

	/** @type {HTMLElement} */
	#bookingSearchFormElement;

	/** @type {HTMLElement} */
	#closeBtn;

	/** @type {HTMLElement} */
	#btnHamburgerToggle;

	/** @type {HTMLElement} */
	#hamburgerMenuWrapper;

	/** @type {HTMLElement} */
	#actionWrapper;

	/** @type {HTMLElement} */
	#menuItems;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		// if (window.innerWidth <= 992) {
			this.#holderElement = holderElement;
			this.#bookingButtons = this.#holderElement.querySelectorAll('.open-booking-search-form-view');
			this.#bookingSearchFormElement = document.querySelector('.booking-search-form-wrapper');
			this.#btnHamburgerToggle = this.#holderElement.querySelector('.btn-hamburger-toggle');
			this.#hamburgerMenuWrapper = this.#holderElement.querySelector('.hamburger-menu-wrapper');
			this.#actionWrapper = document.querySelector('.action-wrapper');
			this.#menuItems = this.#holderElement.querySelectorAll('.menu-item-wrapper');
			this.mobileOnload();
		// }
	}

	async mobileOnload() {
		this.#menuBtn = this.#holderElement.querySelector('.btn-menu');
		this.#menuView = this.#holderElement.querySelector('.menu-view');
		this.#closeBtn = this.#menuView.querySelector('.btn-close');
		this.#displayMobileMenu();
		// this.#handleBookingBtn();
		this.#handleHamburgerBtn();
		this.#adjustPagePaddingTop();
		this.#handleMobileMenuItems();
	}

	#displayMobileMenu() {
		let self = this;

		this.#menuBtn.addEventListener('click', function() {
			if (self.#btnHamburgerToggle.checked) {
				self.#btnHamburgerToggle.click();
			}
			document.querySelector('html').style.overflow = document.querySelector('html').style.overflow === 'hidden' ? 'unset' : 'hidden';
			self.#menuView.style.height = self.#menuView.style.height === '0px' || self.#menuView.style.height === '' ? 'calc(100vh - 10.2rem)' : '0';
		});

		this.#closeBtn.addEventListener('click', function() {
			document.querySelector('html').style.overflow = 'unset';
			self.#menuView.style.height = '0';
		});
	}

	#handleBookingBtn() {
		let self = this;

		this.#bookingButtons.forEach((button) => {
			button.addEventListener('click', function () {
				if (self.#closeBtn) {
					self.#closeBtn.click();
					self.#closeBtn.style.opacity = '1';
					self.#closeBtn.style.zIndex = '9';
				}
				if (self.#hamburgerMenuWrapper.style.height !== '0px' && self.#hamburgerMenuWrapper.style.height !== '') {
					self.#btnHamburgerToggle.click();
				}
				document.querySelector('html').style.overflow = 'hidden';
				self.#bookingSearchFormElement.style.height = '100vh';
				self.#bookingSearchFormElement.style.zIndex = '11';
				self.#actionWrapper.querySelector('.btn-close').style.display = 'inline-block';
				self.#bookingSearchFormElement.querySelector('.next-button-wrapper').style.position = 'fixed';
				self.#bookingSearchFormElement.querySelector('.btn-next').style.position = 'fixed';
				self.#bookingSearchFormElement.querySelector('.btn-submit').style.position = 'fixed';
				self.#bookingSearchFormElement.querySelector('.btn-next').style.opacity = 1;
				self.#bookingSearchFormElement.querySelector('.btn-submit').style.opacity = 1;
				self.#bookingSearchFormElement.querySelectorAll('.booking-search-form-option').forEach(option => {
					option.querySelector('svg').style.opacity = '1';
				});
				if (document.querySelector('.booking-search-form-wrapper').querySelector('.booking-search-form-selection-wrapper.active').getAttribute('id') !== 'selection-0') {
					self.#bookingSearchFormElement.querySelector('.btn-back').style.display = 'inline-block';
				}
			});
		});
	}

	#handleHamburgerBtn() {
		let self = this;

		this.#btnHamburgerToggle.addEventListener('change', function() {
			if (this.checked) {
				if (self.#closeBtn) {
					self.#closeBtn.click();
				}
				document.querySelector('html').style.overflow = 'hidden';
				self.#hamburgerMenuWrapper.style.height = '100vh';
			} else {
				document.querySelector('html').style.overflow = 'unset';
				self.#hamburgerMenuWrapper.style.height = '0';
			}
		})
	}

	#adjustPagePaddingTop() {
		let targetContainer = this.#holderElement.nextElementSibling.querySelector('.container-fluid.mobile-view') ?
			this.#holderElement.nextElementSibling.querySelector('.container-fluid.mobile-view') :
			this.#holderElement.nextElementSibling.querySelector('.mobile-view') ?
			this.#holderElement.nextElementSibling.querySelector('.mobile-view > .container-fluid') :
			this.#holderElement.nextElementSibling.classList.contains('mobile-view') ?
			this.#holderElement.nextElementSibling.querySelector('.container-fluid') :
			this.#holderElement.nextElementSibling.nextElementSibling.classList.contains('mobile-view') ?
			this.#holderElement.nextElementSibling.nextElementSibling.querySelector('.container-fluid') : null;
		targetContainer?.classList.add('subsite-padding-adjustment');
	}

	#handleMobileMenuItems() {
		this.#menuItems.forEach((menuItem) => {
			const subMenuItem = menuItem.nextElementSibling;

			if (subMenuItem) {
				if (menuItem.querySelector('a').getAttribute('href') === null) {
					menuItem.addEventListener('click', (event) => {
						event.preventDefault();
						subMenuItem.style.display = 'grid';
						subMenuItem.querySelectorAll('a').forEach(menuItem => {
							menuItem.style.height = 'auto';
							menuItem.style.paddingBottom = '1rem';
						});
						subMenuItem.style.visibility = 'visible';
						subMenuItem.style.opacity = 1;
						subMenuItem.style.paddingTop = '1.5rem';
						subMenuItem.style.paddingLeft = '3.4rem';
						subMenuItem.style.paddingBottom = '3rem';
						subMenuItem.style.height = subMenuItem.scrollHeight.toString() + 'px';
					});
				}
			}
		});
	}
}
